
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CpBarschartComponent } from './cp-barschart.component';
@NgModule({
  declarations: [CpBarschartComponent],
  exports: [CpBarschartComponent],
  imports: [CommonModule]
})
export class BarsChartModule {}

